import React from 'react';

const Hero = ({children}) => {
	return <div className="hero">{children}</div>
}

export default Hero;